import { render, staticRenderFns } from "./UploadBrochure.vue?vue&type=template&id=3d009722&"
import script from "./UploadBrochure.vue?vue&type=script&lang=js&"
export * from "./UploadBrochure.vue?vue&type=script&lang=js&"
import style0 from "./UploadBrochure.vue?vue&type=style&index=0&id=3d009722&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports